import React from 'react';
import {Body} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import type {CampaignBriefCaptionGuideline} from '@/types/campaign';
import BriefField from './BriefField';
import BriefTag from './BriefTag';
import styles from './CaptionGuidelinesBlock.module.scss';

interface CaptionGuidelinesBlockProps {
  guidelines: CampaignBriefCaptionGuideline[];
  testID?: string;
}

function CaptionGuidelinesBlock({
  guidelines,
  testID = 'caption-guidelines-block',
}: CaptionGuidelinesBlockProps) {
  if (!guidelines.length) {
    return null;
  }

  const sorted = [...guidelines].sort((a, b) => a.weight - b.weight);
  const captions = sorted.filter((g) => g.kind === 'caption');
  const others = sorted.filter(
    (g) => g.kind === 'hashtag' || g.kind === 'mention'
  );

  const prefix = (g: CampaignBriefCaptionGuideline) =>
    g.kind === 'hashtag' ? '#' : '@';

  return (
    <div className={styles.container} data-testid={testID}>
      {captions.length > 0 ? (
        <BriefField label={translate('Captions')}>
          {captions.map((g) => (
            <Body key={g.id} size="md">
              {g.content}
            </Body>
          ))}
        </BriefField>
      ) : null}
      {others.length > 0 ? (
        <BriefField label={translate('Other hashtags and mentions')}>
          <div className={styles.chips}>
            {others.map((g) => (
              <BriefTag key={g.id} label={g.content} prefix={prefix(g)} />
            ))}
          </div>
        </BriefField>
      ) : null}
    </div>
  );
}

export default CaptionGuidelinesBlock;
